var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessthen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53024 15.9698C9.59992 16.0395 9.6552 16.1222 9.69291 16.2132C9.73062 16.3043 9.75003 16.4019 9.75003 16.5004C9.75003 16.599 9.73062 16.6965 9.69291 16.7876C9.6552 16.8786 9.59992 16.9614 9.53024 17.031C9.46056 17.1007 9.37783 17.156 9.28679 17.1937C9.19574 17.2314 9.09816 17.2508 8.99961 17.2508C8.90107 17.2508 8.80349 17.2314 8.71244 17.1937C8.6214 17.156 8.53867 17.1007 8.46899 17.031L0.968988 9.53104C0.899256 9.46139 0.843937 9.37867 0.806194 9.28762C0.768451 9.19657 0.749023 9.09898 0.749023 9.00042C0.749023 8.90186 0.768451 8.80426 0.806194 8.71321C0.843937 8.62216 0.899256 8.53945 0.968988 8.46979L8.46899 0.969792C8.60972 0.829062 8.80059 0.75 8.99961 0.75C9.19864 0.75 9.38951 0.829062 9.53024 0.969792C9.67097 1.11052 9.75003 1.30139 9.75003 1.50042C9.75003 1.69944 9.67097 1.89031 9.53024 2.03104L2.55993 9.00042L9.53024 15.9698Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessthen);
export default __webpack_public_path__ + "static/media/lessthen.1ff578995548c8f93bb57c629e495605.svg";
export { ForwardRef as ReactComponent };